import { replace } from 'connected-react-router';
import { Challenge, isRedirect, PaginatedResponse } from 'model';
import { parse } from 'query-string';
import { combineEpics } from 'redux-observable';
import { Epic } from 'redux/modules/types';
import { combineLatest } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { CHALLENGES_PER_PAGE } from 'utils/config';
import { getChallenge, getChallenges } from './actions';

export const getChallengesEpic: Epic = (action$, _, { request }) =>
  action$.pipe(
    filter(isActionOf(getChallenges.request)),
    mergeMap(({ payload: { search } }) => {
      const query = search ? parse(search) : {};

      return combineLatest([
        request<PaginatedResponse<Challenge>>({
          path: 'challenges',
          params: {
            page: 1,
            pageSize: 1,
            showActive: 'true',
          },
        }),
        request<PaginatedResponse<Challenge>>({
          path: 'challenges',
          params: {
            pageSize: CHALLENGES_PER_PAGE,
            showActive: 'false',
            ...query,
          },
        }),
      ]).pipe(
        mergeMap(([activeResponse, pastResponse]) => {
          const active = activeResponse.results[0] as
            | typeof activeResponse.results[0]
            | undefined;

          return [
            getChallenges.success({
              ...pastResponse,
              active,
            }),
          ];
        }),
        catchError(() => [getChallenges.failure()]),
      );
    }),
  );

export const getChallengeEpic: Epic = (action$, state$, { request }) =>
  action$.pipe(
    filter(isActionOf(getChallenge.request)),
    mergeMap(({ payload: { slug } }) =>
      request<Challenge>({
        path: `challenges/${slug}`,
      }).pipe(
        mergeMap((response) => {
          if (isRedirect(response)) {
            // We think we have a slug, but we actually have an id
            const id = slug;
            const location = state$.value.router.location;

            if (location.pathname === `/challenges/${id}`) {
              return [
                replace({
                  ...location,
                  pathname: `/challenges/${response.mappings[id]}`,
                }),
              ];
            }

            return [];
          }

          return [getChallenge.success(response)];
        }),
        catchError(() => [getChallenge.failure()]),
      ),
    ),
  );

export default combineEpics(getChallengesEpic, getChallengeEpic);
